import { createContext } from "react";

const Location = createContext();
export const Navigatetologinpage = createContext();


export default Location;
